import './rewind.scss';
import { h, Component } from 'preact';
import { IoIosRefresh } from 'react-icons/io';
import { PLAYER_CONTROL_EVENT } from 'constants/events';
import { REWIND_AMOUNT_SECONDS } from 'configuration/defaults';

export const Rewind = ({bus, player, amount = REWIND_AMOUNT_SECONDS}) => {
    const onClick = () => {
        if (player) {
            bus.emit(PLAYER_CONTROL_EVENT.CURRENT_TIME, player.currentTime - amount);
        }
    }

    return (
        <button name="rewind" aria-label="Rewind 15 seconds" onClick={onClick} className="rewind controlBarButton vjs-control vjs-button" title={`Rewind ${amount} Seconds`}>
            <IoIosRefresh aria-hidden="true" />
            <span className="rewindAmount">{parseInt(amount)}</span>
        </button>
    )
}
